module.exports = __webpack_public_path__ + "static/media/quizapp.5f9ada1e.webp";